<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title">Data Sales</h3>
                            <div class="card-tools">
                                <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                                    <i class="fa fa-plus-square"></i>
                                    Add New
                                </button>
                            </div>
                        </div>
                        <!-- /.card-header -->
                        <div class="card-body table-responsive p-0">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th style="width: 10%;">Id Sales</th>
                                        <th>Name</th>
                                        <th>No Hp</th>
                                        <th>Alamat</th>
                                        <th>Kantor</th>
                                        <th style="width: 10%;">#</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="sales in saless.data" :key="sales.idsales">
                                        <td>{{sales.idsales}}</td>
                                        <td class="text-capitalize">{{sales.nama}}</td>
                                        <td class="text-capitalize">{{sales.handphone}}</td>
                                        <td>{{sales.alamat}}</td>
                                        <td>{{sales.alamat}}</td>
                                        <td>
                                            <div class="tanpawrap">
                                                <button class="btn btn-xs btn-info" @click="editModal(sales)"
                                                    title="Edit Data">
                                                    <i class="fa fa-edit"></i>
                                                </button>
                                                <button class="btn btn-xs btn-danger" @click="deleteSales(sales.idsales)"
                                                    title="Edit Data">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="card-footer">
                            <pagination :data="saless" @pagination-change-page="getResults"></pagination>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!$gate.isAdmin()">
                <not-found></not-found>
            </div>

            <!-- Modal -->
            <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" v-show="!editmode">Tambah Data Sales</h5>
                        <h5 class="modal-title" v-show="editmode">Edit Data Sales</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <form @submit.prevent="editmode ? updateSales() : createSales()">
                        <div class="modal-body">
                           
                            <div class="form-group">
                                <label>ID Sales</label>
                                <input v-model="form.idsales" type="number" name="idsales"
                                    class="form-control" :disabled="editmode" :class="{ 'is-invalid': form.errors.has('idsales') }">
                                <has-error :form="form" field="idsales"></has-error>
                            </div>

                            <div class="form-group">
                                <label>Nama</label>
                                <input v-model="form.nama" type="text" name="nama"
                                    class="form-control" :class="{ 'is-invalid': form.errors.has('nama') }">
                                <has-error :form="form" field="nama"></has-error>
                            </div>

                            <div class="form-group">
                                <label>Alamat</label>
                                <input v-model="form.alamat" type="text" name="alamat"
                                    class="form-control" :class="{ 'is-invalid': form.errors.has('alamat') }">
                                <has-error :form="form" field="alamat"></has-error>
                            </div>

                            <div class="form-group">
                                <label>no_hp</label>
                                <input v-model="form.handphone" type="text" name="handphone"
                                    class="form-control" :class="{ 'is-invalid': form.errors.has('handphone') }">
                                <has-error :form="form" field="handphone"></has-error>
                            </div>

                            <div class="form-group">
                                <label>Kantor</label>
                                <select name="prefixcabang" v-model="form.prefixcabang" id="prefixcabang" class="form-control" :class="{ 'is-invalid': form.errors.has('prefixcabang') }" required>
                                    <option value="" selected disabled>-- PILIH KANTOR USER --</option>
                                        <option 
                                            v-for="kantor in kantor_list" :key="kantor.id"
                                            :value="String(kantor.id)">
                                            {{ kantor.value }}
                                        </option>
                                </select>
                                <has-error :form="form" field="prefixcabang"></has-error>
                            </div>
                            
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button v-show="editmode" type="submit" class="btn btn-success">Edit!</button>
                            <button v-show="!editmode" type="submit" class="btn btn-primary">Tambah!</button>
                        </div>
                    </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { onMounted } from 'vue';

    export default {
        name: 'SalesManagement',
        data() {
            return {
                editmode: false,
                saless: {},
                form: new Form({
                    idsales: '',
                    nama: '',
                    alamat: '',
                    handphone: '',
                    kantor_id: '',
                    pswd: '',
                    prefixcabang: '',
                    survey: '',
                }),
                kantor_list: [],
            };
        },

        methods: {
            
            getResults(page = 1) {
                this.$Progress.start();
                axios.get(`api/sales?page=${page}`)
                    .then(({ data }) => (this.saless = data.data))
                    .catch(() => this.showErrorToast('Gagal memuat data sales.'))
                    .finally(() => this.$Progress.finish());
            },

            loadSales() {
                if (!this.$gate.isAdmin()) return;

                axios.get("api/sales")
                    .then(({ data }) => (this.saless = data.data))
                    .catch(() => this.showErrorToast('Gagal memuat data sales.'));
            },


            loadKantor() {
                axios.get("/api/user/kantor_list")
                    .then(response => {
                        this.kantor_list = response.data.data; // Ubah sesuai struktur response
                    })
                    .catch(error => {
                        this.showErrorToast('Gagal memuat data kantor.');
                    });
            },


            showModal(isEdit = false, sales = null) {

                this.editmode = isEdit;
                this.form.reset();

                if (isEdit && sales) {
                    
                    this.form.fill(sales);
                }

                $('#addNew').modal('show');
            },

            newModal() {
                this.showModal();
            },

            editModal(sales) {
                this.showModal(true, sales);
            },

            createSales() {
                this.$Progress.start();
                this.form.post('api/sales')
                    .then(({ data }) => {
                        $('#addNew').modal('hide');
                        this.showSuccessToast(data.message);
                        this.loadSales();
                    })
                    .catch(() => this.showErrorToast('Terjadi kesalahan saat menyimpan data.'))
                    .finally(() => this.$Progress.finish());
            },

            updateSales() {
                this.$Progress.start();
                this.form.put(`api/sales/${this.form.idsales}`)
                    .then(({ data }) => {
                        $('#addNew').modal('hide');
                        this.showSuccessToast(data.message);
                        this.loadSales();
                    })
                    .catch(() => this.showErrorToast('Terjadi kesalahan saat memperbarui data.'))
                    .finally(() => this.$Progress.finish());
            },

            deleteSales(id) {
                Swal.fire({
                    title: 'Yakin untuk menghapus?',
                    text: 'Sales yang memiliki keterkaitan data mungkin tidak dapat dihapus. Lanjutkan?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Ya, Hapus!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.form.delete(`api/sales/${id}`)
                            .then(() => {
                                Swal.fire('Terhapus!', 'Data Sales berhasil dihapus.', 'success');
                                this.loadSales();
                            })
                            .catch((error) => {
                                const message = error?.response?.data?.message || 'Terjadi kesalahan saat menghapus data.';
                                Swal.fire('Hapus Gagal!', message, 'warning');
                            });
                    }
                });
            },

            showSuccessToast(message) {
                Toast.fire({
                    icon: 'success',
                    title: message,
                });
            },

            showErrorToast(message) {
                Toast.fire({
                    icon: 'error',
                    title: message,
                });
            },
        },

        created() {
            this.$Progress.start();
            this.loadSales();
            this.loadKantor();
            this.$Progress.finish();
        },

        onMounted() {
            this.loadSales();
            this.loadKantor();
        },
    };
</script>